<template>
  <div id="assist__course">
    <router-link tag="div" :to="'/courses/' + info.c_id" class="course__item">
      <div class="left">
        <div class="img" :style="$bgd(info.course_img)" />
      </div>
      <div class="right">
        <div class="title">{{ info.title }}</div>
        <div class="subtitle">{{ info.subtitle }}</div>
        <div class="reward" v-if="info.amount && info.lesson_length">
          <i class="anyteachicon anyteach-homeclass"></i>
          <span v-if="info.lesson_length == 1440">{{ info.amount }} 天</span>
          <span v-else>
            <span v-if="info.amount > 1">{{ info.amount }} ×</span>
            <span>{{ info.lesson_length }} 分钟</span>
          </span>
        </div>
      </div>
    </router-link>
    <div class="bottom" v-if="info.assist_status == 1">
      <div class="title" v-if="info.lesson_length == 1440">
        {{ info.assist_user.length * info.amount }} / {{ info.limit_time * info.amount }} 天
      </div>
      <div class="title" v-else>{{ info.assist_user.length }} / {{ info.limit_time }} 次课</div>
      <p class="body">已累计获得课时</p>
    </div>
    <div class="bottom" v-else>
      <div class="title" v-if="info.lesson_length == 1440">
        {{ info.assist_user.length * info.amount }} 天
      </div>
      <div class="title" v-else>{{ info.assist_user.length }} 次课</div>
      <p class="body">可兑换课时</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "AssistCourse",
  props: ["info", "remaining"],
}
</script>

<style lang="scss" scoped>
@import "../style.scss";

#assist__course {
  background: $grey;
  width: calc(100% - 60px);
  margin: 15px auto;
}

.course__item {
  border: none;
  margin: 0;
}

.bottom {
  border-top: 1px solid rgba(0, 0, 0, 0.05);
  padding: 15px 0;

  .title {
    font-size: 1.5rem;
    @include avenir-demi();
    color: $purple;
    padding: 0 0 5px 0;
  }
}
</style>
